module.exports = __webpack_public_path__ + "static/media/interactive-link.00f6b97e.svg";